import React from "react";
import Icon from "../Icon/Icon";

interface Props {
    width?: `${number}rem` | `${number}px`;
    height?: `${number}rem` | `${number}px`;
    color?: "" | "text-midnight-500" | "text-mint-500";
}

const Spinner = ({ width = "14px", height = "14px", color = "text-midnight-500" }: Props) => (
    <Icon
        data-testid="spinner"
        icon="spinner"
        width={width}
        height={height}
        viewBox="0 0 48 48"
        className={`${color} animate-spin-clockwise-infinite`}
        style={{
            width,
            height,
        }}
    />
);

export default Spinner;
